"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BaseButton = require("./BaseButton");
var _Icon = require("../Icon");
var _excluded = ["type", "size", "icon", "iconPosition", "className", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var buttonStyles = function buttonStyles(size, type) {
  return (0, _classnames.default)('btn-classic', {
    'btn-classic-small tw-body-sm-medium': size === 'small'
  }, {
    'btn-classic-large tw-label-medium': size === 'large'
  }, {
    'btn-classic-primary-emphasis shadow-5': type === 'emphasis'
  }, {
    'btn-classic-primary-light': type === 'light'
  }, {
    'btn-classic-primary': !type
  });
};
var iconStyles = function iconStyles(buttonSize, position) {
  return buttonSize === 'large' ? (0, _classnames.default)('h-[24px] w-[24px]', {
    'ml-[8px]': position === 'right'
  }, {
    'mr-[8px]': position === 'left'
  }) : (0, _classnames.default)('h-[16px] w-[16px]', {
    'ml-[4px]': position === 'right'
  }, {
    'mr-[4px]': position === 'left'
  });
};
var PrimaryButton = function PrimaryButton(_ref) {
  var type = _ref.type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    icon = _ref.icon,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? 'right' : _ref$iconPosition,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = buttonStyles(size, type);
  return /*#__PURE__*/_react.default.createElement(_BaseButton.BaseButton, _extends({
    className: (0, _classnames.default)(styles, className)
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center"
  }, icon && iconPosition === 'left' && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: icon,
    className: iconStyles(size, iconPosition),
    "aria-hidden": true
  }), /*#__PURE__*/_react.default.createElement("span", null, children), icon && iconPosition === 'right' && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: icon,
    className: iconStyles(size, iconPosition),
    "aria-hidden": true
  })));
};
exports.PrimaryButton = PrimaryButton;